import { hocSinhHoTroActions } from './hocSinhHoTroActions';
import { hocSinhSelectionActions } from './hocSinhSelectionActions';
export const hocSinhActionsWrapper = {
    hocSinhSelection: hocSinhSelectionActions,
    hocSinhHoTro: hocSinhHoTroActions,
}